<template>
  <div>

    <HeroBanner
      heading="Spend less time on transactions and more time growing your business"
      subheading="PFX is a broker branded auction experience that reduces the countless hours spent on qualifying buyers, providing due diligence, and managing multiple offers."
      theme="dark"
      :image="require('../assets/brokers-hero.jpg')"
      :buttons="['get-started']"
    />

    <div class="split-view clearfix">
      <div class="column text-padding">
        <h2>PFX makes it easy to auction your listings</h2>
        <ul class="icons">
          <li><v-icon color="brand">check</v-icon> Create custom, branded auctions</li>
          <li><v-icon color="brand">check</v-icon> Seamlessly connect to your marketing and listing websites</li>
          <li><v-icon color="brand">check</v-icon> Control auction terms and close</li>
          <li><v-icon color="brand">check</v-icon> Consolidate due diligence documentation</li>
          <li><v-icon color="brand">check</v-icon> Qualify buyers before they bid</li>
        </ul>
      </div>
      <div class="column image-padding easy-image">
      </div>
    </div>

    <div class="container why-pfx">
      <h2 class="align-center">Why PFX</h2>
      <div class="clearfix columns">
        <div class="three-column">
          <div><img :src="require('../assets/why-brand.svg')"/></div>
          <h3>Leverage your Brand</h3>
          <p>PFX Auctions are branded with your company name and logo so all auction participants recognize your firm as the listing agent.</p>
        </div>
        <div class="three-column">
          <div><img :src="require('../assets/why-paperwork.svg')"/></div>
          <h3>Consolidate Paperwork</h3>
          <p>From required disclosures to due diligence items and the purchase agreement, all documents are available for review.</p>
        </div>
        <div class="three-column">
          <div><img :src="require('../assets/why-buyer.svg')"/></div>
          <h3>Get Qualified Buyers</h3>
          <p>Pre-qualify bidders before the auction begins. Buyers upload the documents you specify for your review and approval.</p>
        </div>
      </div>
      <div class="clearfix columns">
        <div class="three-column">
          <div><img :src="require('../assets/why-process.svg')"/></div>
          <h3>Control the Sales Process</h3>
          <p>You set the time frame for buyer qualification and the live auction. Proceed to escrow within your preset timeline.</p>
        </div>
        <div class="three-column">
          <div><img :src="require('../assets/why-close.svg')"/></div>
          <h3>Close with Certainty</h3>
          <p>With due diligence completed up front, there is no renegotiation while in escrow.</p>
        </div>
        <div class="three-column">
          <div><img :src="require('../assets/why-grow.svg')"/></div>
          <h3>Grow Your Business</h3>
          <p>Differentiate yourself with a sales tool that will win you listings. Reinvest the time and money you save to provide more value to your clients.</p>
        </div>
      </div>
    </div>

    <div class="call-to-action-1 align-center">
      <h2>Auction your listings</h2>
      <button class="btn-rounded fat" @click="$store.commit('openGetStartedDialog')">Get Started</button>
    </div>

    <div class="split-view clearfix">
      <div class="column text-padding">
        <h2>Create auctions on your timeline</h2>
        <p>
          Take control of the sales process to better meet your clients' needs. Set the auction registration period,
          the auction open and close dates and the starting price. Upload due diligence documents and specify
          required items for bidders.
        </p>
      </div>
      <div class="column create-auctions-image">
        <div class="image-padding image-overlay">
          <img :src="require('../assets/screenshot-create-listing.jpg')" />
        </div>
      </div>

      <div class="column approve-bidder-image">
        <div class="image-padding image-overlay">
          <img :src="require('../assets/screenshot-approve-bidder.png')" />
        </div>
      </div>
      <div class="column text-padding">
        <h2>Approve qualified bidders</h2>
        <p>
          Get notified when buyers register for your auctions. Review their registration form and required documents.
          Once you approve authorized buyers, they can participate in a fair and secure auction process.
        </p>
      </div>

      <div class="column text-padding">
        <h2>Monitor your auctions, anytime, from anywhere</h2>
        <p>
          Login to your company dashboard to get a real-time overview on all auction activities,
          from the number and amount of bids to auction and more. From here, you can also create and
          edit your auction pages.
        </p>
      </div>
      <div class="column monitor-dashboard-image">
        <div class="image-padding image-overlay">
          <img :src="require('../assets/screenshot-monitor-dashboard.png')" />
        </div>
      </div>
    </div>

    <div class="call-to-action-2 align-center">
      <h2>Ready to auction your listings with PFX?</h2>
      <button class="btn-rounded fat" @click="$store.commit('openGetStartedDialog')">Get Started</button>
    </div>

    <div class="videos clearfix" v-if="hideVideos">
      <div class="column video1">
        <h2>Watch PFX Videos to learn more</h2>
      </div>
      <div class="column video2 pointer" @click="$store.commit('openYouTubeDialog', 'E5yFcdPAGv0')"><!-- TODO change video -->
        <div class="title">Get Started <div class="length">5:40</div></div>
        <div class="play" @click="$store.commit('openYouTubeDialog', 'drIRh_YOS1E')"></div>
      </div>
      <div class="column video3 pointer" @click="$store.commit('openYouTubeDialog', 'HyHNuVaZJ-k')"><!-- TODO change video -->
        <div class="title">Create Listing <div class="length">8:00</div></div>
        <div class="play" @click="$store.commit('openYouTubeDialog', 'drIRh_YOS1E')"></div>
      </div>
      <div class="column video4 pointer" @click="$store.commit('openYouTubeDialog', 'GgwE94KZJ7E')"><!-- TODO change video -->
        <div class="title">Approve Bidding <div class="length">4:32</div></div>
        <div class="play"></div>
      </div>
    </div>

    <div class="container faq-section">
      <h2>Get answers to commonly asked questions</h2>
      <FaqAgents :embed="true" />
    </div>

  </div>
</template>

<script>
  import HeroBanner from './elements/HeroBanner.vue'
  import FaqAgents from './FaqAgents.vue'
  import { supportEmail } from '../utils/PfxUtils.js'

  export default {
    name: 'AboutBrokers',
    components: {
      FaqAgents,
      HeroBanner
    },
    data() {
      return {
        supportEmail,
        hideVideos: process.env.config.frontend.hideVideos
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .container {
    margin: 0 auto;
    padding: 0;
  }

  h2 {
    font-family: 'Encode Sans', sans-serif;
    font-size: 24px;
    font-weight: 600;
  }

  .easy-image {
    background-image: url('../assets/brokers-building.jpg');
    background-size: cover;
    background-position: center;
    height: 471px;
  }

  .why-pfx {
    padding: 100px 50px;

    h2 {
      margin-bottom: 59px;
    }
    .columns {
      padding: 0 0 2em;
      text-align: center;
      img {
        height: 60px;
      }
    }
    h3 {
      font-family: 'Encode Sans', sans-serif;
      font-weight: 600;
      font-size: 16px;
    }
    p {
      font-size: 16px;
    }
  }

  .call-to-action-1 {
    margin: 0 auto;
    padding: 41px 0 55px;
    background-color: #1B292E;
    background-image: url('../assets/signup-banner.svg');
    background-size: cover;
    background-position: bottom left;
    color: #fff;
    text-shadow: 2px 2px 2px #000;
  }

  .create-auctions-image,
  .approve-bidder-image,
  .monitor-dashboard-image {
    background-size: cover;
    background-position: center;
    height: 609px;
  }
  .create-auctions-image {
    background-image: url('../assets/brokers-building.jpg');
  }
  .approve-bidder-image {
    background-image: url('../assets/brokers-cameraman.jpg');
  }
  .monitor-dashboard-image {
    background-image: url('../assets/brokers-reflection.jpg');
  }
  .image-overlay {
    background-color: rgba(#fff, .5);
    width: 100%;
    height: 100%;
    text-align: center;
    img {
      padding: 55px;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .call-to-action-2 {
    margin: 0 auto;
    padding: 90px 0 100px;
    background-color: #202020;
    background-size: contain;
    color: #fff;
  }

  .faq-section {
    padding: 100px 40px 120px;
    h2 {
      margin-bottom: 50px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AboutBrokers.vue